import React from 'react';
import { AiOutlineShoppingCart, AiOutlineHeart, AiOutlineEye } from 'react-icons/ai';
import { Global } from '../Variables/Global';
import { Link } from 'react-router-dom';

const ProductGridAR = (props) => {
  return (
    <>
            <div className="gf-product shop-grid-view-product">
                <div className="image">
                    {!props.product.InStock && (
                    <span className="out-of-stock-badge">
                        نفد من المخزون
                    </span>
                )}
                    <span href={"/AR/DetailedProduct/" + props.product.ProductName.replace(/ /g, "-") + "/" + props.product.ProductId + "/" + props.product.DefaultVariation.ProductVariationId}>
                        {/* <span className="onsale">Sale!</span> */}
                        {
                            props.product.DefaultVariation.Image2 == "" ? (
                                <Link to={"/AR/DetailedProduct/" + props.product.ProductName.replace(/ /g, "-") + "/" + props.product.ProductId + "/" + props.product.DefaultVariation.ProductVariationId}>
                                    <img src={Global.PHOTO_URL + props.product.DefaultVariation.Image1} alt={props.product.ProductName} />
                                    {/* onMouseOver={e => (e.currentTarget.src = Global.PHOTO_URL + product.Image1)}
                              onMouseOut = {e => (e.currentTarget.src = Global.PHOTO_URL + product.Image0)}  */}
                                </Link>
                            ) : (
                                <Link to={"/AR/DetailedProduct/" + props.product.ProductName.replace(/ /g, "-") + "/" + props.product.ProductId + "/" + props.product.DefaultVariation.ProductVariationId}>
                                    <img src={Global.PHOTO_URL + props.product.DefaultVariation.Image1} alt={props.product.ProductName}
                                        onMouseOver={e => (e.currentTarget.src = Global.PHOTO_URL + props.product.DefaultVariation.Image2)}
                                        onMouseOut={e => (e.currentTarget.src = Global.PHOTO_URL + props.product.DefaultVariation.Image1)}
                                    />

                                </Link>
                            )
                        }
                    </span>

                    <div className="product-hover-icons">
                        <a data-tooltip="أضف إلى سلة التسوق" href={"/AR/DetailedProduct/" + props.product.ProductName.replace(/ /g, "-") + "/" + props.product.ProductId + "/" + props.product.DefaultVariation.ProductVariationId}>
                            {/* <span className="icon_cart_alt"></span> */}
                            <AiOutlineShoppingCart className='mb-1'  style={{ color: 'white' }} />

                        </a>
                        {
                            props.WishListItems.find(obj => obj.ProductId === props.product.ProductId) ? (
                                <a data-tooltip="إزالة من المفضلة" onClick={() => props.HandleRemoveFromWishList(props.product.ProductId)}>
                                    <AiOutlineHeart className='mb-1' style={{ color: 'white' }} />
                                </a>
                            ) : (
                                <a data-tooltip="أضف إالى المفضلة" onClick={() => props.HandleAddToWishList(props.product.ProductId, props.product.DefaultVariation.ProductVariationId)}>
                                    <AiOutlineHeart className='mb-1' style={{ color: 'white' }} />
                                </a>
                            )
                        }
                        {/* <a href="#" data-tooltip="Quick view" data-bs-toggle="modal"
													data-bs-target="#quick-view-modal-container"> */}
                        {/* <a data-tooltip="نظرة سريعة" onClick={() => {props.setShowModal(true);props.setProductDetails(props.product)}}>
                            <AiOutlineEye className='mb-1' style={{ color: 'white' }} />
                        </a> */}

                    </div>
                </div>
                <div className="product-content">
                    <div className="product-categories">
                        {/* <a className='RemUnderline' href="shop-left-sidebar.html">JALLAB - SYRUP</a> */}
                    </div>
                    <h3 className="product-title"><a href={"/AR/DetailedProduct/" + props.product.ProductName.replace(/ /g, "-") + "/" + props.product.ProductId + "/" + props.product.DefaultVariation.ProductVariationId} className='RemUnderline' dangerouslySetInnerHTML={{ __html: props.product.ProductNameAR }}></a></h3>
                    <div className="price-box">
                        {
                            props.product.DefaultVariation.SalePrice === 0 ? (
                                <>
                                    <span className="discounted-price RemUnderline">AED{props.product.DefaultVariation.RegularPrice}</span>

                                </>
                            ) : (
                                <>
                                    <span className="discounted-price RemUnderline">AED{props.product.DefaultVariation.SalePrice}</span>
                                    <span className="main-price RemUnderline">AED{props.product.DefaultVariation.RegularPrice}</span>
                                </>
                            )
                        }

                    </div>
                    {/* <p className="product-description" dangerouslySetInnerHTML={{ __html: props.product.DescriptionAR }}></p> */}
                </div>

            </div>
        </>
  )
}

export default ProductGridAR